import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './styles/polished-theme.css';
import { ToastContainer } from "react-toastify";
import ProtectedRoute from './components/protection/protectionRoute';
import HomeSubmasterPage from './page/dashboardSubmaster/homeSubmasterPage';
import AuthenticationSubmasterPage from './page/auth/submasterAuthenticationPage';
import AuthenticationMasterPage from './page/auth/masterAuthenticationPage';
import LandingPage from './page/landing/landingPage';
import HomeMasterPage from './page/dashboardMaster/homeMasterPage';
import ConfigMasterDrivePage from './page/dashboardMaster/configMasterDrivePage';
import ProtectedRouteMaster from './components/protection/protectionRouteMaster';
import ConfigMasterSubmasterPage from './page/dashboardMaster/ConfigMasterSubmasterPage';
import ConfigMaterCategories from './page/dashboardMaster/configMasterCategoriesPage';
import ConfigMasterCancelamento from './page/dashboardMaster/configMasterCancelamentos';
import ConfigSubmasterAnimalPage from './page/dashboardSubmaster/configSubmasterAnimalPage';
import ConfigSubmasterClient from './page/dashboardSubmaster/configSubmasterClient';
import ConfigSubmasterEmployeesPage from './page/dashboardSubmaster/configSubmasterEmployeesPage';
import ConfigSubmasterUserPage from './page/dashboardSubmaster/configSubmasterUserPage';
import ConfigSubmasterEpiPage from './page/dashboardSubmaster/ConfigSubmasterEpiPage';
import ConfigDocumentEmployeePage from './page/dashboardSubmaster/configDocumentEmployeePage';
import ConfigEditTextDoc from './page/dashboardSubmaster/configSubmasterEditTextDocPage';
import ConfigReportDocument from './page/dashboardSubmaster/configSubmasterReportDocumentPage';
import ConfigSubmasterCompanyPage from './page/dashboardSubmaster/configSubmasterCompanyPage';
import DataSubmasterPage from './page/dashboardSubmaster/dataSubmasterPage';
import ConfigAdditionalReportPage from './page/dashboardSubmaster/configAdditionalReportPage';
import ConfigSubmasterStockPage from './page/dashboardSubmaster/configSubmasterStockPage';

const BUILD_REFRESH_KEY = 'epi-track-build-refresh';
const SERVICE_WORKER_RESET_KEY = 'epi-track-service-worker-reset';
const CACHE_BUST_QUERY_PARAM = '_appv';

const getCacheBustedUrl = () => {
  const url = new URL(window.location.href);
  url.searchParams.set(CACHE_BUST_QUERY_PARAM, Date.now().toString());
  return url.toString();
};

const getCurrentMainScriptUrl = () =>
  Array.from(document.scripts)
    .map((script) => script.src)
    .find((src) => /\/static\/js\/main\.[^/]+\.js$/i.test(src)) ?? '';

const unregisterLegacyServiceWorkers = async () => {
  if (!('serviceWorker' in navigator)) {
    return false;
  }

  const registrations = await navigator.serviceWorker.getRegistrations();
  let hasUnregisteredServiceWorker = false;

  for (const registration of registrations) {
    const workers = [registration.active, registration.waiting, registration.installing];
    const isLegacyServiceWorker = workers.some(
      (worker) => worker?.scriptURL && /(service-worker|sw\.js|workbox)/i.test(worker.scriptURL)
    );

    if (!isLegacyServiceWorker) {
      continue;
    }

    const unregistered = await registration.unregister();
    hasUnregisteredServiceWorker = hasUnregisteredServiceWorker || unregistered;
  }

  return hasUnregisteredServiceWorker;
};

const refreshWhenBuildChanges = async () => {
  const currentMainScriptUrl = getCurrentMainScriptUrl();

  if (!currentMainScriptUrl) {
    return false;
  }

  try {
    const response = await fetch(`/asset-manifest.json?ts=${Date.now()}`, {
      cache: 'no-store',
      headers: {
        'Cache-Control': 'no-cache',
      },
    });

    if (!response.ok) {
      return false;
    }

    const manifest = await response.json();
    const nextMainScriptPath = manifest?.files?.['main.js'];

    if (!nextMainScriptPath) {
      return false;
    }

    const nextMainScriptUrl = new URL(nextMainScriptPath, window.location.origin).href;

    if (nextMainScriptUrl === currentMainScriptUrl) {
      sessionStorage.removeItem(BUILD_REFRESH_KEY);

      const cleanUrl = new URL(window.location.href);
      if (cleanUrl.searchParams.has(CACHE_BUST_QUERY_PARAM)) {
        cleanUrl.searchParams.delete(CACHE_BUST_QUERY_PARAM);
        window.history.replaceState(null, '', cleanUrl.toString());
      }

      return false;
    }

    if (sessionStorage.getItem(BUILD_REFRESH_KEY) === nextMainScriptUrl) {
      return false;
    }

    sessionStorage.setItem(BUILD_REFRESH_KEY, nextMainScriptUrl);
    window.location.replace(getCacheBustedUrl());
    return true;
  } catch {
    return false;
  }
};

const rootElement = document.getElementById('root') as HTMLElement;
document.documentElement.lang = 'pt-BR';
document.documentElement.setAttribute('translate', 'no');
document.documentElement.classList.add('notranslate');
document.body?.setAttribute('translate', 'no');
document.body?.classList.add('notranslate');
rootElement.setAttribute('translate', 'no');
rootElement.classList.add('notranslate');

const renderApp = () => {
  const root = ReactDOM.createRoot(rootElement);

  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/acesso" element={<AuthenticationSubmasterPage />} />
          <Route path="/MasterAuth" element={<AuthenticationMasterPage />} />

          <Route
            path="/HomeSubmasterPage"
            element={
              <ProtectedRoute>
                <HomeSubmasterPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ConfigSubmasterAnimalPage"
            element={
              <ProtectedRoute>
                <ConfigSubmasterAnimalPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ConfigSubmasterClient"
            element={
              <ProtectedRoute>
                <ConfigSubmasterClient />
              </ProtectedRoute>
            }
          />
          <Route
            path='/ConfigSubmasterEmployeesPage'
            element={
              <ProtectedRoute>
                <ConfigSubmasterEmployeesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path='/ConfigSubmasterUserPage'
            element={
              <ProtectedRoute>
                <ConfigSubmasterUserPage />
              </ProtectedRoute>
            }
          />
          <Route
            path='/ConfigSubmasterUserPage'
            element={
              <ProtectedRoute>
                <ConfigSubmasterUserPage />
              </ProtectedRoute>
            }
          />
          <Route
            path='/ConfigSubmasterEpiPage'
            element={
              <ProtectedRoute>
                <ConfigSubmasterEpiPage />
              </ProtectedRoute>
            }
          />
          <Route
            path='/ConfigSubmasterCompanyPage'
            element={
              <ProtectedRoute>
                <ConfigSubmasterCompanyPage />
              </ProtectedRoute>
            }
          />
          <Route
            path='/ConfigSubmasterStockPage'
            element={
              <ProtectedRoute>
                <ConfigSubmasterStockPage />
              </ProtectedRoute>
            }
          />
          <Route
            path='/ConfigDocumentEmployeePage'
            element={
              <ProtectedRoute>
                <ConfigDocumentEmployeePage />
              </ProtectedRoute>
            }
          />
          <Route
            path='/ConfigDocumentEmployeePhotoPage'
            element={
              <ProtectedRoute>
                <ConfigDocumentEmployeePage photoByEpi />
              </ProtectedRoute>
            }
          />
          <Route
            path='/ConfigEditTextDoc'
            element={
              <ProtectedRoute>
                <ConfigEditTextDoc />
              </ProtectedRoute>
            }
          />
          <Route
            path='/ConfigReportDocument'
            element={
              <ProtectedRoute>
                <ConfigReportDocument />
              </ProtectedRoute>
            }
          />
          <Route
            path='/ConfigAdditionalReportPage'
            element={
              <ProtectedRoute>
                <ConfigAdditionalReportPage />
              </ProtectedRoute>
            }
          />

          {/** PARA USO INTERNO DE CONTROLE DE EMPRESA - ESSE Ã‰ O ACESSO MASTER */}
          <Route
            path="/DataSubmasterPageUseInterno"
            element={
              <DataSubmasterPage />
            }
          />

          {/*=================================================================================================================== ROTAS PARA MASTER. */}
          <Route
            path="/HomeMasterPage"
            element={
              <ProtectedRouteMaster>
                <HomeMasterPage />
              </ProtectedRouteMaster>
            }
          />
          <Route
            path="/ConfigMasterSubmasterPage"
            element={
              <ProtectedRouteMaster>
                <ConfigMasterSubmasterPage />
              </ProtectedRouteMaster>
            }
          />
          <Route
            path="/ConfigMasterDrivePage"
            element={
              <ProtectedRouteMaster>
                <ConfigMasterDrivePage />
              </ProtectedRouteMaster>
            }
          />
          <Route
            path="/ConfigMaterCategories"
            element={
              <ProtectedRouteMaster>
                <ConfigMaterCategories />
              </ProtectedRouteMaster>
            }
          />
          <Route
            path="/ConfigMasterCancelamento"
            element={
              <ProtectedRouteMaster>
                <ConfigMasterCancelamento />
              </ProtectedRouteMaster>
            }
          />
        </Routes>
        <ToastContainer />
      </BrowserRouter>
    </React.StrictMode>
  );
};

const bootstrapApp = async () => {
  if (process.env.NODE_ENV === 'production') {
    const hasResetServiceWorker = sessionStorage.getItem(SERVICE_WORKER_RESET_KEY) === '1';

    if (!hasResetServiceWorker) {
      const removedLegacyServiceWorker = await unregisterLegacyServiceWorkers();
      sessionStorage.setItem(SERVICE_WORKER_RESET_KEY, '1');

      if (removedLegacyServiceWorker) {
        window.location.replace(getCacheBustedUrl());
        return;
      }
    }

    const hasReloadedForNewBuild = await refreshWhenBuildChanges();
    if (hasReloadedForNewBuild) {
      return;
    }
  }

  renderApp();
};

void bootstrapApp();
